import { readFaceComparisonPayload } from '@hakimo-ui/hakimo/util';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ComparisonGrid, HeaderStrip } from './utils';

export function FaceComparisonRoot() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const payload = useMemo(
    () => (id ? readFaceComparisonPayload(id) : null),
    [id]
  );

  if (!payload) {
    return (
      <div className="container mx-auto p-6">
        <p className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
          This comparison link has expired or is invalid. Please reopen it from
          the alarm details page.
        </p>
      </div>
    );
  }

  return (
    <div className="container mx-auto flex h-screen flex-col p-6">
      <HeaderStrip payload={payload} />
      <ComparisonGrid payload={payload} />
    </div>
  );
}

export default FaceComparisonRoot;
